import createActions from '../../../modules/create-actions';
import { createReducer } from 'redux-act';
import { loop, Effects } from 'redux-loop';
import { TERMS_STATE } from '../lib/constants';
import ajaxLogin from '../lib/ajaxLogin';

export const Actions = createActions('TermsOfUseAcceptance', [
  'setPage',
  'ajaxLoginStart', 'ajaxLoginSuccess', 'internalFailure',
  'termsClick', 'termsClose',
  'rejectTerms', 'hideErrorMessage',
  'signupClick',
]);

export const getReducer = (initialState) => {
  return createReducer({
    [Actions.setPage](state, page) {
      return state.set('page', page);
    },

    [Actions.ajaxLoginStart](state, loginValues) {
      return loop(
        state.set('loginValues', loginValues),
        Effects.promise(ajaxLogin, loginValues)
      );
    },

    [Actions.ajaxLoginSuccess](state, response) {
      let updatedState = state;
      const { authenticated } = response;
      // if !authenticated then POST to Rails (submit form)
      if (!authenticated) {
        updatedState = updatedState.set('submit', true);
      } else {
        // if authenticated then:
        updatedState = updatedState.set('submit', true);
      }
      return updatedState;
    },

    [Actions.internalFailure](state) {
      return state
        .set('termsState', TERMS_STATE.SHOW_ERROR)
        .set('internalError', true);
    },

    [Actions.termsClick](state) {
      const internalError = !state.get('termsContent');
      const termsState = internalError ? TERMS_STATE.SHOW_ERROR : TERMS_STATE.SHOW_MODAL;
      return state
        .set('termsState', termsState)
        .set('internalError', internalError);
    },

    [Actions.termsClose](state) {
      return state
        .set('termsState', TERMS_STATE.HIDE);
    },

    [Actions.signupClick](state) {
      return state
        .set('submit', true);
    },

    [Actions.rejectTerms](state) {
      return state.set('termsState', TERMS_STATE.SHOW_ERROR);
    },

    [Actions.hideErrorMessage](state) {
      return state
        .set('termsState', TERMS_STATE.HIDE)
        .set('internalError', false);
    },
  }, initialState);
};

export const reducer = getReducer();
